import React from 'react';
import styled from 'styled-components';
import { DesktopOnly } from './MobileOnly';

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, 0.9);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const ModalContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 90vw;
  font-family: 'jost', sans-serif;

  max-height: 90vh;
  color: white;
  overflow: hidden;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const ModalLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

const ModalRight = styled.div`
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

const Image = styled.img`
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
`;

const Video = styled.video`
  max-width: 100%;
  max-height: 80vh;
`;


// Styled component for the modal information section
const ModalInfo = styled.div`
  font-family: 'eb-garamond', serif;
  margin: 0;

  h3 {
    font-size: 2.5rem;
    font-family: 'jost', sans-serif;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: clamp(1rem, 1.5vw, 1.125rem);
    /* margin-bottom: 1rem; */
    font-family: 'eb-garamond', serif;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Navigation = styled.div`
    margin-top: 1rem;
    display: flex;
    gap: 1rem;
`;

const Button = styled.button`
    background: none;
    color: white;
    border: 1px solid white;
    padding: 0.5rem 1rem;
    transition: 0.3s ease;
    font-family: 'jost', sans-serif;
    font-weight: 400;
    cursor: pointer;
    &:hover {
        background-color: white;//rgba(var(--primary-color));
        color: rgb(var(--primary-color));
        /* -webkit-text-stroke: 1px white; */
    }
`;

const CloseButton = styled.button`
    position: fixed;
    font-family: 'jost', sans-serif;
    top: 1rem;
    right: 1rem;
    background: none;
    color: white;
    border: none;
    font-size: 4rem;
    font-weight: 400;
    cursor: pointer;
    transition: color 0.3s ease;
  &:hover {
    color: rgba(var(--primary-color));
    -webkit-text-stroke: 1px white;
  }
`;

const ArtworkModal = ({
  artwork,
  onClose,
  selectedImageIndex,
  onNextImage,
  onPrevImage
}) => {
  if (!artwork) return null;
  const currentSrc = artwork.source[selectedImageIndex];
  const handleBackgroundClick = (e) => {
    // Only close if click was on background, not modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalBackground onClick={handleBackgroundClick}>
      <ModalContent>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <ModalLeft>
          {artwork.type === 'image' ? (
            <Image src={`/images/${currentSrc}`} alt={artwork.title} />
          ) : (
            <Video controls autoPlay loop muted>
              <source src={`/videos/${artwork.source}`} type="video/mp4" />
              Your browser does not support the video tag.
            </Video>
          )}
        </ModalLeft>
        <ModalRight>
          <ModalInfo>
            {artwork.title && <h3>{artwork.title}</h3>}
            {artwork.year && <p><em>{artwork.year}</em></p>}
            {artwork.description && <p>{artwork.description}</p>}
            </ModalInfo>
          {artwork.type === 'image' && artwork.source.length > 1 && (
            <DesktopOnly>
                <Navigation>
                <Button onClick={onPrevImage}>← </Button>
                <Button onClick={onNextImage}> →</Button>
            </Navigation>
            </DesktopOnly>
            )}
        </ModalRight>
      </ModalContent>
    </ModalBackground>
  );
};

export default ArtworkModal;
